<template>
    <el-menu default-active="1-4-1" style="width:8em " class="el-menu-vertical-demo" text-color="#000" active-text-color="#FF6600">
        <el-menu-item @click="clickMenu(item)" :index="item.title" v-for="item in menuData" :key="item.id"
            :style="{ backgroundColor: parseInt(current) === parseInt(item.id) ? '#fff5e6' : '' }">
            <span slot="title">{{ item.title }}</span>
        </el-menu-item>
    </el-menu>
</template>

<style lang="less" scoped>
.el-menu-vertical-demo {
    // width: 150px;
    padding: 1em;
    border-radius: 10px;
}

.el-menu {
    height: 100%;
    margin: 1em 1em 1em 2em;

    .el-menu-item {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 3em;
        font-size: 0.9em;
        border-radius: 5px;
    }

    .el-menu-item:focus,
    .el-menu-item:hover {
        outline: 0;
        background-color: #fff5e6;
    }
}
</style>

<script>
export default {
    props: {
    menuData: {
      type: Array,
      default: () => []
    },
    innerWidth: {
            type: Number,
            default: 0
        }
  },
    data() {
        return {
            current: 1,
            
        };
    },

    methods: {
        clickMenu(item) {
            // 更新 current 的值
            
            this.current = item.id;
            this.$emit('menu-item-clicked', item); 
        },
    },
    computed: {

    }
}
</script>